import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import landingEn from '../locales/en/landing.json';
import landingAr from '../locales/ar/landing.json';

const resources = {
  en: {
    landing: landingEn,
  },
  ar: {
    landing: landingAr,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'ar',
    defaultNS: 'landing',
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
